import React, { useState } from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { Col, Row } from 'react-bootstrap';
import elsterService from '../../services/company/elsters.service';
const isPayloadInvalid = function () {
  let {
    start_date,
    end_date
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!start_date || !end_date) return true;
  const [sd, sm, sy] = start_date.split('/').map(Number);
  const [ed, em, ey] = end_date.split('/').map(Number);
  return new Date(sy, sm - 1, sd) >= new Date(ey, em - 1, ed);
};
const FinancialYearModal = _ref => {
  let {
    show,
    onHide,
    companyId,
    elster = {},
    startDate = null,
    endDate = null,
    warningMessage,
    showPreviousElsterDates,
    afterSubmitActions
  } = _ref;
  const {
    t
  } = useTranslation();
  const [payload, setPayload] = useState({
    id: elster.id,
    start_date: startDate,
    end_date: endDate
  });
  const {
    createElster,
    updateElster
  } = elsterService.useCrud(companyId);
  const changePayload = (key, value) => {
    setPayload({
      ...payload,
      [key]: value
    });
  };
  const body = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("h2", null, t('enter_dates_for_financial_year')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: async dateValue => changePayload('start_date', dateValue),
    selected: payload.start_date
  })), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: async dateValue => changePayload('end_date', dateValue),
    selected: payload.end_date
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, isPayloadInvalid(payload) ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, t('enter_dates_and_make_sure_start_date_is_before_end_date')) : /*#__PURE__*/React.createElement("p", null, t('dates_correct_you_can_submit')))), warningMessage && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "text-warning"
  }, warningMessage))), showPreviousElsterDates && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, `${t('start_date_changing')}: ${startDate} >> ${payload.start_date}`), /*#__PURE__*/React.createElement("p", null, `${t('end_date_changing')}: ${endDate} >> ${payload.end_date}`))));
  const updateAction = async () => {
    await updateElster({
      ...payload
    });
    afterSubmitActions && (await afterSubmitActions());
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: t('add_financial_year'),
    renderBody: () => body,
    onHide: onHide,
    onSubmit: () => elster?.id ? updateAction() : createElster(payload),
    disabled: isPayloadInvalid(payload)
  });
};
export default FinancialYearModal;